import React, { useEffect, useState } from "react";
import AccountLayout from "./AccountLayout";
import moment from "moment/moment";
import { isEmpty } from "lodash";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../../context/AuthContext";
import { apiGet } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import NoData from "../../component/NoData";
import { t } from "i18next";

const SpinReport = () => {
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const [listing, setListing] = useState([]);
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
  });
  const handel = () => {
    setFilter({
      ...filter,
      page: filter?.page + 1,
    });
    getData(
      {
        ...filter,
        page: filter?.page + 1,
      },
      "add",
    );
  };
  const getData = async (object = filter, type) => {
    try {
      const { status, data } = await apiGet(apiPath.spinReport, object);

      const result = status == 200 && data?.success ? data.results?.data : [];
      setData(result);

      if (type == "add") {
        setListing([...listing, ...data?.results?.data]);
      } else {
        setListing(data?.results?.data);
      }
    } catch (error) {}
  };
  useEffect(() => {
    if (!isEmpty(user)) {
      getData();
    }
  }, [user]);
  return (
    <AccountLayout title={t("SpinReport")}>
      <ul
        _ngcontent-serverapp-c221247831
        className="cricket-list-content ng-tns-c221247831-105"
      >
        {listing?.length > 0 ? (
          listing?.map((res) => {
            return (
              <li
                style={{ color: "white" }}
                _ngcontent-serverapp-c3238644402
                className={`accordion-wrap ng-tns-c3238644402-106 ng-star-inserted`}
              >
                <div
                  _ngcontent-serverapp-c3238644402
                  className={`accordion-header ng-tns-c3238644402-106 ng-star-inserted`}
                >
                  <div
                    style={{ display: "block" }}
                    _ngcontent-serverapp-c3238644402
                    className="main-info ng-tns-c3238644402-106"
                  >
                    <div
                      _ngcontent-serverapp-c3238644402
                      className="title ng-tns-c3238644402-106"
                    >
                      <span
                        _ngcontent-serverapp-c3238644402
                        className="category-type ng-tns-c3238644402-106"
                      >
                        {res.spin}
                      </span>

                      <div
                        _ngcontent-serverapp-c3238644402
                        className="parlay-type ng-tns-c3238644402-106"
                        style={{ textTransform: "uppercase" }}
                      >
                        {t("Spin")}
                      </div>
                    </div>
                  </div>

                  <div
                    _ngcontent-serverapp-c3238644402
                    className="bet-bid ng-tns-c3238644402-106"
                  >
                    {/* {!isEmpty(res?.casinoBetId) ? "Game Info" : "Remark"} :
                    <span
                      _ngcontent-serverapp-c3238644402
                      className="ng-tns-c3238644402-106"
                      style={{ marginLeft: "4px" }}
                    >
                      {!isEmpty(res?.casinoBetId)
                        ? `${res?.platform} - ${res?.gameInfo}`
                        : res?.remark || "N/A"}
                    </span> */}
                  </div>
                  <div
                    _ngcontent-serverapp-c3238644402
                    className="bet-placed ng-tns-c3238644402-106"
                  >
                    {t("Date")} :
                    <span
                      _ngcontent-serverapp-c3238644402
                      className="ng-tns-c3238644402-106"
                      style={{ marginLeft: "4px" }}
                    >
                      {moment(res?.createdAt || res?.timeInserted).format(
                        "YYYY-MM-DD HH:MM:SS",
                      )}
                    </span>
                  </div>
                </div>
              </li>
            );
          })
        ) : (
          <NoData />
        )}
      </ul>

      {data?.hasNextPage && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            onClick={handel}
            style={{ width: "50%" }}
            _ngcontent-serverapp-c2684251700
            className="button btn-primary ng-tns-c2684251700-125"
          >
            {t("LoadMore")}
          </div>
        </div>
      )}
    </AccountLayout>
  );
};

export default SpinReport;
